import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Navigation() {
  const { user, logout } = useAuth();

  return (
    <nav className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex-shrink-0 flex items-center font-semibold">
              WhoDatNumber
            </Link>
            <Link to="/learn" className="text-sm text-gray-600 hover:text-gray-900 hidden sm:inline">
              Learn
            </Link>
            <Link to="/privacy" className="text-sm text-gray-600 hover:text-gray-900 hidden sm:inline">
              Privacy
            </Link>
            <Link to="/terms" className="text-sm text-gray-600 hover:text-gray-900 hidden sm:inline">
              Terms
            </Link>
          </div>
          
          <div className="flex items-center">
            {user ? (
              <>
                {user.isAdmin && (
                  <Link 
                    to="/admin"
                    className="mr-4 text-gray-700 hover:text-gray-900"
                  >
                    Admin
                  </Link>
                )}
                <Link 
                  to="/dashboard"
                  className="mr-4 text-gray-700 hover:text-gray-900"
                >
                  Dashboard
                </Link>
                <button
                  onClick={logout}
                  className="text-gray-700 hover:text-gray-900"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link 
                to="/login"
                className="text-gray-700 hover:text-gray-900"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navigation; 
